import React, { useEffect, useState, useContext } from 'react'
import Wrapper from '../../../../components/common/Wrapper/Wrapper'
import organisms from '../../../../components/organisms'
import { handleReportDownload } from '../../../../constants/utils'
import service from "../../../../api/services";
import { useToasts } from 'react-toast-notifications';
import * as XLSX from "xlsx"
import { HeaderHeading } from '../../../../Context'

const { BulkApprove } = organisms

const Index = () => {
    const [data, setData] = useState<any>([])
    const [isLoading, setIsLoading] = useState(false)
    const { setHeader }: any = useContext(HeaderHeading);

    const { addToast } = useToasts();

    useEffect(() => {
        setHeader("Product - Bulk Approve")
    }, [])

    const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIsLoading(true);
        const reader = new FileReader();
        reader.onload = (event: ProgressEvent<FileReader>) => {
            try {
                const data = event.target?.result;
                if (typeof data === 'string') {
                    const workbook = XLSX.read(data, { type: 'binary' });


                    const parsedData: { [key: string]: any[] } = {};
                    workbook.SheetNames.forEach((sheetName) => {
                        const sheet = workbook.Sheets[sheetName];
                        parsedData['Product_list'] = XLSX.utils.sheet_to_json(sheet);
                    });
                    if (parsedData) {
                        setData(parsedData?.Product_list);
                    }


                } else {
                    throw new Error('Invalid file data');
                }
            } catch (error) {
                console.error('Error parsing Excel file:', error);
            } finally {
                setIsLoading(false);
            }
        };

        reader.onerror = (event: ProgressEvent<FileReader>) => {
            console.error('Error reading the file:', event?.target?.error);
            setIsLoading(false);
        };

        if (e.target.files && e.target.files[0]) {
            reader.readAsBinaryString(e.target.files[0]);
        } else {
            console.error('No file selected');
            setIsLoading(false);
        }
    };



    const handleBulkSubmit = async () => {
        const product_ids = data?.map((item: any) => item.product_id)

        let payload = {
            product_ids: product_ids
        }
        try {
            let response = await service.BulkEditService.approveUpload(payload)
            if (response.status) {
                addToast(response.data.message, {
                    appearance: 'success',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
            }

        } catch (error: any) {
            console.log("Error", error)
            addToast(error.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }



    return (
        <Wrapper>
            <div className='col '>
                <BulkApprove
                    data={data}
                    handleFileUpload={handleFileUpload}
                    downloadExcel={handleBulkSubmit}
                />
            </div>
            {isLoading &&
                <div
                    style={{
                        width: '100vw',
                        height: '100vh',
                        display: 'flex',
                        justifyContent: 'center',
                        position: 'absolute',
                        alignItems: 'center'
                    }}
                    className="loading-One"
                >
                    <div
                        style={{
                            position: 'fixed',
                            top: '50%',
                            left: "50%",
                            zIndex: '9999'
                        }}
                        className="spinner-border text-primary loading-Two" role="status">

                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            }
        </Wrapper>
    )
}

export default Index